import { render, staticRenderFns } from "./FormControlPagesUrl.vue?vue&type=template&id=ae0b13b0"
import script from "./FormControlPagesUrl.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlPagesUrl.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports